import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';

import { BlockModel } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

@Component({
  selector: 'empathy-change-question-type-dialog',
  templateUrl: 'change-question-type-dialog.component.html',
  styleUrl: './change-question-type-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangeQuestionTypeDialogComponent implements OnInit {
  faExclamationCircle = faExclamationCircle;

  constructor(
    private dialogRef: MatDialogRef<ChangeQuestionTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { questionCode: string; targetTypeText: string; affectedQuestions: Question[]; affectedBlocks: BlockModel[] }
  ) {}

  ngOnInit(): void {
    this.dialogRef.addPanelClass('empathy-confirm__dialog');
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
